export default "__VITE_ASSET__DHZzV4LH__"